import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/app/app/middleware/auth.global.ts";
import route_45global from "/app/app/middleware/route.global.ts";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  route_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}